import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialog } from "primeng/confirmdialog";

@Component({
  selector: "jni-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  imports: [ConfirmDialog, CommonModule],
  providers: [ConfirmationService],
})
export class ConfirmDialogComponent implements OnInit {
  @Input() dialogHeading = "";
  @Input() dialogMessage = "";
  @Input() hideIcon = false;
  @Output() confirmDialogStatus = new EventEmitter<boolean>();
  @Input() headerMsg = "";

  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.deleteAlert(this.dialogMessage);
  }

  deleteAlert(popupmessage: string) {
    this.confirmationService.confirm({
      message: popupmessage,
      header: this.headerMsg || "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        this.confirmDialogStatus.emit(true);
      },
      reject: () => {
        this.confirmDialogStatus.emit(false);
      },
    });
  }
}
